import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {SettingsService} from "../../_services/settings.service";
import {HttpClient} from "../../_services/httpclient";
import {Router} from "@angular/router";
import {UserService} from "../../_services/user.service";
import {AuthenticationService} from "../../_services/authentication.service";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {transition, trigger, style, animate} from '@angular/animations';
import swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: [
    './login.component.css',
    '../../../../node_modules/sweetalert2/dist/sweetalert2.min.css',
  ],
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('fadeInOutTranslate', [
      transition(':enter', [
        style({opacity: 0}),
        animate('400ms ease-in-out', style({opacity: 1}))
      ]),
      transition(':leave', [
        style({transform: 'translate(0)'}),
        animate('400ms ease-in-out', style({opacity: 0}))
      ])
    ])
  ]
})
export class LoginComponent implements OnInit {

  loginForm: FormGroup;

  constructor(
              public settings: SettingsService,
              private http: HttpClient,
              private router: Router,
              private userService: UserService,
              private authenticationService: AuthenticationService) {

    this.loginForm = new FormGroup({
      username: new FormControl(null, [Validators.required]),
      password: new FormControl(null, [Validators.required])
    });
  }

  ngOnInit() {
    this.userService.cleanUserInfo();
  }

  login($ev, value: any){
    $ev.preventDefault();
    for (let c in this.loginForm.controls) {
      this.loginForm.controls[c].markAsTouched();
    }

    if (this.loginForm.valid) {
      this.authenticationService.login(value.username, value.password)
        .subscribe(result => {

          console.log(result);

          if (result === true) {
            this.router.navigate(['/main']);
          } else {
            swal(
              'คำเตือน',
              result.toString(),
              'error'
            );
          }
        });
    }else {
      swal(
        'คำเตือน',
        'กรุณากรอกชื่อเข้าระบบและรหัสผ่าน',
        'error'
      );
    }
  }

}



// WEBPACK FOOTER //
// /Users/pakornduangtrakan/Snocko/other/backend-auto/src/app/pages/Nlogin/login.component.ts